/**
 * Sprint E — mobile sticky buy bar on product pages.
 * Shows when the main purchase block scrolls off-screen; mirrors price/variant/ATC state.
 */
(function () {
  function selectNativeSwatch(target) {
    var swatch = target.closest('.product_form .swatch-element');
    if (!swatch) return;

    var wrapper = swatch.closest('[data-variant-option-value-wrapper]');
    var input = wrapper && wrapper.querySelector('[data-variant-option-value]');
    if (!input || input.disabled) return;

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var optionsSelection = input.closest('options-selection');
    if (optionsSelection && typeof optionsSelection._onOptionChange === 'function') {
      optionsSelection._onOptionChange();
    }
  }

  document.addEventListener('click', function (event) {
    selectNativeSwatch(event.target);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var swatch = event.target.closest('.product_form .swatch-element');
    if (!swatch) return;
    event.preventDefault();
    selectNativeSwatch(event.target);
  });
})();

(function () {
  var MOBILE_MAX = 798;

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  function getProductSection() {
    return document.querySelector('.js-product_section');
  }

  function getStickyBar() {
    return document.querySelector('[data-lb-mobile-buy-bar]');
  }

  function getPurchaseBlock(section) {
    return section && section.querySelector('.purchase-details');
  }

  function getMainAtc(section) {
    return section && section.querySelector('[data-add-to-cart-trigger]');
  }

  function getPriceText(section) {
    if (!section) return '';
    var priceUi = section.querySelector('[data-price-ui]');
    if (!priceUi) return '';

    var priceNode =
      priceUi.querySelector('.price-ui__price') ||
      priceUi.querySelector('.money') ||
      priceUi.querySelector('[class*="price"]');

    if (priceNode) {
      return priceNode.textContent.replace(/\s+/g, ' ').trim();
    }

    return priceUi.textContent.replace(/\s+/g, ' ').trim();
  }

  // Drop noise segments (e.g. the default "No Notch") so the compact sticky
  // bar shows only meaningful options — keeps Shelves as tidy as KittaParts.
  function cleanVariantText(text) {
    if (!text) return '';
    var parts = text.split(/\s*[\/·]\s*/);
    var kept = parts.filter(function (part) {
      var p = part.trim();
      return p && !/^no\s+notch$/i.test(p);
    });
    return kept.join(' · ');
  }

  function getVariantText(section) {
    if (!section) return '';

    var labels = [];
    section.querySelectorAll('.vsk-swatch-item.vsk--selected').forEach(function (el) {
      var label =
        el.getAttribute('aria-label') ||
        el.getAttribute('title') ||
        el.getAttribute('data-value') ||
        el.textContent;
      if (label) labels.push(label.trim());
    });

    if (labels.length) {
      return labels.join(' · ');
    }

    var select = section.querySelector('select[data-variants]');
    if (select && select.selectedIndex >= 0 && select.value !== 'not-selected') {
      var optionText = select.options[select.selectedIndex].textContent.trim();
      return cleanVariantText(optionText.replace(/\s*-\s*[\$£€].*$/, '').trim());
    }

    section.querySelectorAll('.variant-selection input[type="radio"]:checked').forEach(function (checked) {
      var radioLabel = checked.id && section.querySelector('label[for="' + checked.id + '"]');
      var text = radioLabel ? radioLabel.textContent : checked.value;
      if (text) labels.push(text.trim());
    });

    if (labels.length) {
      return cleanVariantText(labels.join(' · '));
    }

    return '';
  }

  function syncStickyBar(section, bar) {
    var priceEl = bar.querySelector('[data-lb-sticky-price]');
    var variantEl = bar.querySelector('[data-lb-sticky-variant]');
    var stickyAtc = bar.querySelector('[data-lb-sticky-atc]');
    var mainAtc = getMainAtc(section);

    var priceText = getPriceText(section);
    if (priceText && priceEl) {
      priceEl.textContent = priceText;
    }

    var variantText = getVariantText(section);
    if (variantText && variantEl) {
      variantEl.textContent = variantText;
    }

    if (stickyAtc && mainAtc) {
      var disabled = mainAtc.disabled || mainAtc.classList.contains('disabled');
      stickyAtc.disabled = disabled;
      stickyAtc.classList.toggle('disabled', disabled);
      var labelSpan = mainAtc.querySelector('.text');
      if (labelSpan && labelSpan.textContent.trim()) {
        stickyAtc.textContent = labelSpan.textContent.trim();
      }
    }
  }

  function setBarVisible(bar, visible) {
    if (!bar) return;
    bar.hidden = !visible;
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    document.body.classList.toggle('lb-mobile-buy-bar--visible', visible);
  }

  function init() {
    if (!isMobile()) return;

    var section = getProductSection();
    var bar = getStickyBar();
    var purchase = getPurchaseBlock(section);

    if (!section || !bar || !purchase) return;

    var stickyAtc = bar.querySelector('[data-lb-sticky-atc]');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        var mainAtc = getMainAtc(section);
        if (mainAtc && !mainAtc.disabled) {
          mainAtc.click();
        }
      });
    }

    syncStickyBar(section, bar);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setBarVisible(bar, !entry.isIntersecting);
        });
      },
      { root: null, threshold: 0, rootMargin: '0px 0px -8px 0px' }
    );

    observer.observe(purchase);

    var syncTarget = section.querySelector('[data-product-form]') || section;
    var syncObserver = new MutationObserver(function () {
      syncStickyBar(section, bar);
    });

    syncObserver.observe(syncTarget, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-label', 'title']
    });

    section.addEventListener('change', function () {
      syncStickyBar(section, bar);
    });
    section.addEventListener('click', function (e) {
      if (e.target.closest('.vsk-swatch-item, [data-variant-option], .variant-selection')) {
        setTimeout(function () {
          syncStickyBar(section, bar);
        }, 50);
      }
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        setBarVisible(bar, false);
        observer.disconnect();
        syncObserver.disconnect();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
